import { gql } from "@apollo/client";

export default gql`
  {
    producers
  }
`;
